<template>
  <div class="exportTemplate">
    <el-dropdown class="el-dropdown__buttons" @command="handleCommand" v-authority="exportAuthority" :hide-on-click="false">
      <el-button>
        保单导出<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="none">
          <el-input type="text" v-model="templateVal" clearable placeholder="请输入模版名称进行检索" @input="inputChange"></el-input>
        </el-dropdown-item>
        <el-dropdown-item :command="item.id" v-for="(item,index) in templateList" :divided="index===0" :key="item.id">{{item.sceneName}}
        </el-dropdown-item>
        <el-dropdown-item command="item.id" divided key="item.id"></el-dropdown-item>
        <el-dropdown-item :divided="false" icon="el-icon-plus" v-if="!isFeiche && +dynamicQueryType!==4" command="addTemplate" key="addTemplate"
          v-authority="customExportTemplate">自定义表头</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <ybl-dialog :visible="dialog.visible" :title="dialog.title" :width="dialog.width" @close="close" @confirm="dialogSubmit"
      :showFooter="![17,50,400].includes(+dialog.step) || isBindQrcode" :showHeader="![50].includes(+dialog.step)">
      <template-fields ref="dialog" v-if="+dialog.step===40" :item="currentTemplate" @change="submitTemplate"
        :templates="originTemplateList"></template-fields>
      <ybl-qrcode ref="dialog" v-else-if="+dialog.step===400" @next="nextValidate"></ybl-qrcode>
      <ybl-export ref="dialog" v-else :taskId="taskId" :isFeiche="isFeiche" :busiType="sceneCategory" @close="close" @goTo="goTo"></ybl-export>
    </ybl-dialog>
  </div>
</template>
<script>
import templateFields from '@/views/finance/components/templateFields'
import { tool, openNavUrl } from '@/utils'
import { field } from '@/data/field'
import { mapGetters } from 'vuex'
export default {
  name: 'exportTemplate',
  props: {
    sceneCategory: { // 筛选场景类型
      type: Number | String,
      default: () => 1
    },
    exportSceneCategory: { // 导出模版场景类型
      type: Number | String,
      default: () => 2
    },
    isFeiche: { // 是否非车
      type: Boolean,
      default: () => false
    },
    exportAuthority: { // 导出权限值
      type: String | Number | Array,
      default: () => '0000' // '0000'表示拥有权限
    },
    customExportTemplate: { // 自定义导出模版权限
      type: String | Number | Array,
      default: () => '0000' // '0000'表示拥有权限
    },
    dynamicQueryType: {
      type: String | Number,
      default: () => '' //  0 保单查询 1 财务明细 2下游结算 3 上游结算 4 奖励结算
    },
    isUltimate: { // 是否 旗舰版 （多商户查询）
      type: Boolean,
      default: () => false
    },
    system: {
      type: Object,
      default: () => { }
    },
    custom: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      templateList: [],
      originTemplates: [],
      originTemplateList: [], // 原始导出模版
      currentTemplate: { label: '下游结算报表模版', status: '', value: 40, childrens: [] },
      dialog: {
        visible: false,
        title: '查询条件设置',
        width: '',
        step: 1 // 1 条件设置 2 列表字段设置
      },
      partner: {
        branchList: [], // 存储旗舰版下 （子商户）
        props: { label: 'partnerName', value: 'partnerId' },
        defaultVal: [],
        originBranchList: []
      },
      taskId: '',
      templateVal: '',
      isBindQrcode: false // 是否绑定公众号
    }
  },
  created () {
    if (this.exportSceneCategory) { // 判断是否存在存在导出功能
      this.currentTemplate = field.sceneCategory.find(item => +item.value === +this.exportSceneCategory)
      this.currentTemplate = { ...this.currentTemplate, childrens: [] }

      this.queryExportBusiSceneConfig(this.exportSceneCategory).then(data => {
        // let _data = data.dto || []
        this.getExportTemplates(data || [])
      })
    }
  },
  mounted () {
  },
  components: {
    templateFields
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER',
      'commonData'
    ]),
    userInfo () {
      return (this.CUSTOMER_LOGINCUSTOMER && this.CUSTOMER_LOGINCUSTOMER.data) || {}
    },
    Pratner () {
      return (this.userInfo && this.userInfo.Pratner) || ''
    },
    subdomain () {
      return (this.Pratner && this.Pratner.subdomain) || ''
    },
    isRole () {
      return this.subdomain === 'role'
    }
  },
  methods: {
    handleCommand (command) {
      this.currentCommand = command
      switch (command) {
        case 'addTemplate':
          this.dialog.step = 40
          this.dialog.title = `新增${this.currentTemplate.label}`
          this.open()
          break
        case 'none':
          break
        default:
          this.dialog.step = 400
          this.open()
          break
      }
    },
    submitTemplate (item) {
      const { exportSceneCategory } = this
      let _items = item.items || []
      if (+exportSceneCategory === 8) { // 非车模板
        _items = item.items.reduce((arr, cur) => {
          arr = [...arr, ...cur.checkedItems]
          return arr
        }, [])
      }

      let form = {
        configJson: '', // 字段配置,JSON串
        customerId: 0, // 会员id
        enableGlobal: this.isRole ? 1 : 2, // 场景类型，1：系统 2：个人
        id: 0, // 主键id
        organizationIds: '',
        partnerId: 0, // 商户Id
        sceneCode: '', // 场景代码
        sceneDesc: '', // 场景描述
        sceneLabel: this.isRole ? 'default' : '', // 场景标签
        sceneName: item.sceneName, // 场景名称
        status: 1, // 状态 1：有效 2：禁用
        version: 0,
        orgAuthorization: item.orgAuthorization && Array.isArray(item.orgAuthorization) ? item.orgAuthorization.join(',') : item.orgAuthorization, // 授权组织
        sceneCategory: this.exportSceneCategory// 场景使用类型 1：保单查询 2:保单导出 3：上游结算报表查询 4：上游结算报表导出 5：财务明细报表查询 6：财务明细报表导出

      }
      let fieldsOrderDto = { // 排序规则
        ascend: 0, // 排序规则 1升序 0降序
        fieldId: '', // 字段id
        fieldName: '' // 字段名
      }
      let configInfoDto = {
        availableList: _items.map(item => ({
          id: item.id
        })), // this.selectedFields,
        searchList: [], // this.selectedItems,
        fieldsOrderDto: {
          ascend: fieldsOrderDto.ascend,
          fieldId: fieldsOrderDto.fieldId,
          fieldName: fieldsOrderDto.fieldName
        },
        groupTitleList: item.groupTitleList
      }
      form.configInfoDto = configInfoDto
      form.id = item.sceneId
      this.addOrUpdateBusiSceneConfig(form).then(({ data }) => {
        this.refresh()
      })
    },
    refresh () {
      this.queryExportBusiSceneConfig(this.exportSceneCategory).then(data => {
        // let _data = data.dto || []
        this.getExportTemplates(data || [])
        this.close()
      })
    },
    addOrUpdateBusiSceneConfig (params) { // 添加场景
      return this.$store.dispatch('busiAddOrUpdateBusiSceneConfig', params).then(data => {
        console.log(data)
        return data
      })
    },
    inputChange (val) {
      this.debounce()(val, this)
    },
    debounce: tool.debounce(function (val, that) {
      that.filterTemplate(val)
    }, 200, this),
    filterTemplate (val) {
      if (!val) {
        this.templateList = [...this.originTemplates]
        return
      }
      this.templateList = this.originTemplates.filter(item => item.sceneName.includes(val))
    },
    getExportTemplates (data) {
      let _customTemplate = data.filter(item => +item.sceneType === 2)
      let _defaultTemplate = data.filter(item => +item.sceneType === 1 && item.sceneLabel === 'default')
      this.templateList = [..._defaultTemplate, ..._customTemplate]
      this.originTemplates = [...this.templateList]
      this.originTemplateList = data
    },
    queryExportBusiSceneConfig (id) {
      let params = {
        sceneCategory: id, // 4：上游结算报表导出  6：财务明细报表导出 8 非车导出模版
        needAuthorization: false // 是否需要字段权限 true 显示，false 不显示
      }
      return this.$store.dispatch('busiQueryExportBusiSceneConfig', params).then(data => {
        console.log(data)
        return (data.dto || []).filter(c => +c.status === 1)
      })
    },
    nextValidate (item, openId) {
      if (item === 'change') {
        this.dialog.title = '安全验证'
        this.isBindQrcode = true
      } else {
        this.captcha = item === 'continue' ? '' : item
        this.addExportTask(this.currentCommand).then((data) => {
          this.taskId = data.data
          this.dialog.step = 50
          this.open()
        })
      }
    },
    addExportTask (exportSceneId) {
      let size = 10
      let index = 0
      /* let searchFields = this.custom.searchList.map(item => ({
        fieldId: item.id,
        operateType: '',
        val: Array.isArray(item.defaultVal) ? (item.defaultVal === ['', ''] ? '' : item.defaultVal.join(',')) : (item.defaultVal === [] ? '' : item.defaultVal)
      })) */
      let searchFields = this.custom.searchList.map(item => {
        let val = Array.isArray(item.defaultVal) ? (item.defaultVal === ['', ''] ? '' : item.defaultVal.join(',')) : (item.defaultVal === [] ? '' : item.defaultVal)
        return {
          fieldId: item.id,
          operateType: '',
          val: val
        }
      })

      console.log('searchFields=', searchFields)
      let newSearchCondition = JSON.stringify(searchFields)
      let loadSummary = this.currentSearchCondition !== newSearchCondition
      this.currentSearchCondition = newSearchCondition
      let scene = this.custom.scene// tabList[+this.sceneIndex]
      let { configInfoDto } = scene || this.system.scene
      let { fieldsOrderDto } = configInfoDto

      const { configInfoDto: systemConfigInfo } = this.system.scene
      const { fieldsOrderDto: systemFieldsOrder } = systemConfigInfo
      let partnerIds = this.partner.defaultVal
      if (this.partner.defaultVal && this.partner.defaultVal.length === 0) {
        partnerIds = this.partner.originBranchList.map(item => item.partnerId)
      }
      let searchParams = {
        sceneId: (scene && scene.id) || this.system.scene.id,
        searchFields: searchFields,
        sortField: {
          ascend: fieldsOrderDto.fieldId ? fieldsOrderDto.ascend : systemFieldsOrder.ascend, // 升序降序
          fieldId: fieldsOrderDto.fieldId || systemFieldsOrder.fieldId // 排序列Id
        },
        Paging: {
          Ascending: this.Ascending,
          DataCount: 0,
          OrderBy: this.OrderBy,
          SkipCount: index * size,
          TakeCount: size
        },
        partnerIds: this.isUltimate ? partnerIds.join(',') : this.Pratner.partnerid, // 20001//
        loadFlag: {
          loadSummary: loadSummary
        },
        supportMultiPartner: this.isUltimate,
        dynamicQueryType: this.dynamicQueryType
      }
      let params = {
        addTime: '', // 添加时间
        busiParam: JSON.stringify(searchParams), // 请求json
        busiSceneId: searchParams.sceneId, // 场景id
        busiType: this.isFeiche ? 200 : this.sceneCategory, // '1', // 业务类型 1:场景保单导出 // sceneCategory = 7 表示非车
        clientIP: '',
        curRecord: '', // 当前已导出记录数、分页请求
        customerId: '', // 商户ID
        detail: '', // 明细信息
        fileId: '', // attachmentfile id
        fileName: '', // 文件名称
        partnerId: '', // 商户ID
        remark: '',
        startTime: '', // 开始执行时间
        status: '', // 状态 -1：已删除 1：待处理 2：处理中 4：成功 16：已取消
        taskId: '', // 任务ID
        taskType: '0', // 任务类型 0：导出 1：导入
        title: '',
        totalRecord: '', // 导出记录数
        updateTime: '', // 更新时间
        userId: '',
        userName: '',
        exportSceneId: exportSceneId // 导出场景id
      }
      params.headers = {
        'captcha': this.captcha
      }
      return this.$store.dispatch('exportAddExportTask', params).then(data => {
        return data
      })
    },
    open () {
      this.dialog.width = +this.dialog.step === 40 ? '80%' : '60%'
      if (+this.dialog.step === 400) {
        this.dialog.width = '300px'
        this.dialog.title = '扫码绑定公众号'
      }
      this.dialog.visible = true
    },
    close () {
      this.dialog.step = 1
      this.dialog.visible = false
    },
    dialogSubmit () {
      this.$refs['dialog'].submit()
    },
    goTo () {
      this.close()
      let url = this.isFeiche ? '/feiche/policy/task' : `/insurance/task?busiType=${this.sceneCategory}`
      this.goToRouter(url)
    },
    goToRouter (url, target = 'blank') {
      if (target === 'blank') {
        openNavUrl(url, `保单任务列表`, location.host, 'blank', false, 0, 'n11006')
      } else {
        this.$router.push({ path: url })
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/exportTemplate.vue